import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { waitForTick } from 'pdf-lib';
import { Subject } from 'rxjs';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-fhe-records',
  templateUrl: './fhe-records.component.html',
  styleUrls: ['./fhe-records.component.css']
})

export class FheRecordsComponent implements OnInit, OnDestroy {
  users: any[] = [];
  dtOptions: DataTables.Settings = {};

  @ViewChild(DataTableDirective, {static: false})
  dtElement!: DataTableDirective;

  value: any;
  // We use this trigger because fetching the list of users can take a while,
  // thus we ensure the data is fetched before rendering
  dtTrigger: Subject<any> = new Subject<any>();

  constructor(private userService: UserService) { }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 50
    };

    this.userService.getFhePublic().toPromise().then((res: any) => {
      this.users = res.users;

      this.dtTrigger.next();
    });
  }

  // Manual to rerender table
  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {

      // Destroy the table first
      dtInstance.destroy();

      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }
  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }
}
